import { BriefcaseBusinessIcon, PlusIcon } from "lucide-react";
import { Link } from "react-router";

import { Button } from "@/components/ui/button";

import { useCurrentCompanyId } from "@/hooks";

export const JobsEmptyState = () => {
  const currentCompanyId = useCurrentCompanyId();

  return (
    <div className="flex w-[524px] flex-col items-center gap-6">
      <BriefcaseBusinessIcon
        className="h-28 w-28 text-slate-700"
        strokeWidth="0.75"
      />
      <div className="flex flex-col items-center gap-4">
        <p className="text-center text-3xl font-semibold text-slate-700">
          Post your first job
        </p>
        <p className="text-center text-xl text-slate-600">
          Create a job to start receiving applications, manage your candidates,
          and more
        </p>
        <Button className="rounded-full" variant="outline" asChild>
          <Link to={`/companies/${currentCompanyId}/jobs/create`}>
            <PlusIcon className="h-4 w-4" />
            Post job
          </Link>
        </Button>
      </div>
    </div>
  );
};
